import React, { Component } from 'react'
import { translate } from 'react-i18next'
import Spinner from './Spinner'

class VCGallery extends Component {
  constructor(props) {
    super(props)
    this.state = {
      media: []
    }

    props.mediaIds.split(',').forEach(id => {
      if (props.media[id] === undefined)
        props.getMedia(id)
    })
  }

  static getDerivedStateFromProps(props, state) {
    // FIXME: should check if media is not equal prev state!
    const media = []
    props.mediaIds.split(',').forEach(id => {
      if (props.media[id] !== undefined)
        media.push(props.media[id])
    })
    return { media }
  }

  render() {
    // FIXME: handle errors and loaders

    if (this.state.media.length === 0)
      return <Spinner>{this.props.t('msg.loadingImage', { count: 100 })}</Spinner>

    return (
      <div className={this.props.className}>
        {this.state.media.map((item, key) => (
          <img key={key} src={item.getSrc()} alt={item.getTitle()} /> 
        ))}
      </div>
    )
  }
}

export default translate()(VCGallery)



// WEBPACK FOOTER //
// ./src/components/VCGallery.js